module.exports = __webpack_public_path__ + "static/media/blog2-image.7489afad.jpg";